

var validateNumber = (rule, value, callback) => {

};

export const form = {
  // payment1: "",
  // payment2: "",
  profession: "",   // 行业
  business: "",     // 商家
  store: "",        // 店铺

}
export const rules = {
  // payment1: [
  //   { type: 'number', message: '请输入数字', trigger: 'blur' },
  // ],
  // payment2: [
  //   { type: 'number', message: '请输入数字', trigger: 'blur' },
  //   // { validator: validateNumber, trigger: 'change' }
  // ]
}


// WEBPACK FOOTER //
// ./src/views/base/trade/data.js